import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import {
	DishAssignmentContext,
	IDishAssignmentContext,
	TActiveItemToDisplay,
} from 'modules/Menu/Dishes/DishAssignment/dishAssignmentState/dishAssignmentContext';
import React, { useContext } from 'react';
import style from './SectionsSwitcher.module.scss';

const SectionsSwitcher: React.FC = () => {
	const {
		changeActiveItemToDisplay,
		activeItemToDisplay,
		categories,
		IDsSelectedCategories,
		IDsSelectedSubcategories,
	} = useContext<IDishAssignmentContext>(DishAssignmentContext);

	const buttonClasses = (itemName: TActiveItemToDisplay) =>
		classNames(style.button, { [style.withoutHover]: activeItemToDisplay === itemName });

	const categoriesButtonActiveState = activeItemToDisplay === 'categories' || !categories.length;
	const subCategoriesButtonActiveState =
		activeItemToDisplay === 'subCategories' || !Object.keys(IDsSelectedCategories).length;
	const dishesButtonActiveState = activeItemToDisplay === 'dishes' || !Object.keys(IDsSelectedSubcategories).length;

	return (
		<div data-test="SectionsSwitcher" className={style.container}>
			<Button
				theme={categoriesButtonActiveState ? 'primaryBlue' : 'secondary'}
				className={buttonClasses('categories')}
				onClick={() => changeActiveItemToDisplay('categories')}
				disabled={!categories.length}>
				<Text translationNameSpace="listing" translationKey="categoriesLabel" asFragment={true} />
			</Button>
			<Button
				theme={subCategoriesButtonActiveState ? 'primaryBlue' : 'secondary'}
				className={buttonClasses('subCategories')}
				onClick={() => changeActiveItemToDisplay('subCategories')}
				disabled={!Object.keys(IDsSelectedCategories).length}>
				<Text translationNameSpace="listing" translationKey="subcategoriesLabel" asFragment={true} />
			</Button>
			<Button
				theme={dishesButtonActiveState ? 'primaryBlue' : 'secondary'}
				className={buttonClasses('dishes')}
				onClick={() => changeActiveItemToDisplay('dishes')}
				disabled={!Object.keys(IDsSelectedSubcategories).length}>
				<Text translationNameSpace="listing" translationKey="dishesLabel" asFragment={true} />
			</Button>
		</div>
	);
};

export default SectionsSwitcher;
